import Big from 'big.js';
import { AddCartItemParams } from 'smg/customer-api/carts';
import { ShowError } from 'smg/errors';
import QueryString from 'smg/querystring';
import { DollarFormat } from 'smg/util';
import * as carts from '../carts';
import { DrawPrepaymentDeposits } from '../components/prepayment-deposits';

void main();

async function main() {
    const errorId = document.querySelector('#error-div') as HTMLElement;

    const quoteID = QueryString().get('quote');
    if (quoteID) {
        await carts.
            AddCartItem(
                { quoteID },
                {
                    promptToCheckout: false,
                    hideCartLink: true,
                },
            ).
            catch(() => errorId.classList.remove('d-none'));
    }
    const orderID = QueryString().get('order');
    if (orderID) {
        await carts.
            AddCartItem(
                { orderID },
                {
                    promptToCheckout: false,
                    hideCartLink: true,
                },
            ).
            catch(() => errorId.classList.remove('d-none'));
    }
    const newCartItem = QueryString().get('new');
    if (newCartItem) {
        try {
            await carts.AddCartItem(JSON.parse(newCartItem) as AddCartItemParams, {
                promptToCheckout: false,
            });
        } catch (e) {
            ShowError(e);
        }
    }
    const cartID = QueryString().get('cart');
    if (cartID) {
        await carts.
            AddCartItem(
                { cartID },
                {
                    promptToCheckout: false,
                    hideCartLink: true,
                },
            ).
            catch(() => errorId.classList.remove('d-none'));
    }
    void drawCart();
}

async function drawCart() {
    const cartResp = await carts.GetCart('cartItems,totals,pendingDepositOrders').catch(() => undefined);
    // Update Order Summary

    const $orderSummary = document.querySelector('#order-summary') as HTMLElement;
    const $totalAmt = $orderSummary.querySelector('#total-amount') as HTMLElement;
    const $subtotalAmt = $orderSummary.querySelector('#subtotal-amount') as HTMLElement;
    const $prepaymentAmt = $orderSummary.querySelector('#prepayment-amount') as HTMLElement;
    const $prepaymentLine = $prepaymentAmt.closest('.pricing-line') as HTMLElement;
    const $prepaymentDeposits = $orderSummary.querySelector('#prepayment-deposits') as HTMLElement;
    const $availableDiscountAmt = $orderSummary.querySelector('#available-discount-amount') as HTMLElement;
    const $availableDiscountLine = $availableDiscountAmt.closest('.pricing-line') as HTMLElement;
    const $goToCheckoutBtn = $orderSummary.querySelector('#to-checkout') as HTMLButtonElement;

    const $cardContainer = document.querySelector('#cart-item-cards-container') as HTMLElement;
    const $emptyCartPlaceholder = document.querySelector('#cart-empty-placeholder') as HTMLElement;

    if (!cartResp?.cartItems.length) {
        $totalAmt.textContent = '$0.00';
        $subtotalAmt.textContent = '$0.00';
        $prepaymentLine.classList.add('d-none');
        $prepaymentDeposits.classList.add('d-none');
        $availableDiscountLine.classList.add('d-none');
        $goToCheckoutBtn.classList.add('disabled');
        $emptyCartPlaceholder.classList.remove('d-none');
        document.querySelectorAll('.cart-item-card:not(#cart-empty-placeholder)').forEach($el => $el.remove());
    } else {
        $goToCheckoutBtn.classList.remove('disabled');
        $emptyCartPlaceholder.classList.add('d-none');
        document.querySelectorAll('.cart-item-card:not(#cart-empty-placeholder)').forEach($el => $el.remove());
        const totalAmt = cartResp.totals.total;
        const subtotalAmt = cartResp.totals.subtotal;

        $totalAmt.textContent = DollarFormat(totalAmt);
        $subtotalAmt.textContent = DollarFormat(subtotalAmt);

        // total comes back net of the project deposit credit, so without this
        // row the summary visibly doesn't add up against the item cards.
        // Display as -$X.XX so it reads as a credit; checkout shows the same
        // line in its full breakdown.
        const prepayment = cartResp.totals.prepayment;
        if (prepayment.gt(0)) {
            $prepaymentAmt.textContent = DollarFormat(Big(0).sub(prepayment));
            $prepaymentLine.classList.remove('d-none');
        } else {
            $prepaymentLine.classList.add('d-none');
        }
        const availableDiscount = cartResp.totals.availableDiscount;
        if (availableDiscount.eq(0)) {
            $availableDiscountLine.classList.add('d-none');
        } else {
            $availableDiscountAmt.textContent = DollarFormat(availableDiscount);
            $availableDiscountLine.classList.remove('d-none');
        }
        DrawPrepaymentDeposits($prepaymentDeposits, cartResp.pendingDepositOrders);
        for (const cartItem of cartResp.cartItems) {
            const $card = await carts.DrawQuoteOrOrderCartItem({
                cartItemInit: cartItem,
                deleteSuccess: drawCart,
                restoreSuccess: drawCart,
            });
            if (!$card) {
                continue;
            }
            $cardContainer.appendChild($card);
        }
    }
    document.querySelector('#cart-item-card-loading-placeholder')?.remove();
}